import React, { createContext, useReducer, useState } from "react";

export const GlobalContext = createContext({});

const GlobalProvider = ({children}) => {
   
    const [isDarkMode, setIsDarkMode]   = useState(false);

    return (
        <GlobalContext.Provider
            value={{
                isDarkMode,
               // socket
            }}
        >
            {children}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider;